import { Component, EventEmitter, Input, Output } from '@angular/core';
import { BaseModalComponent } from '../base-modal/base-modal.component';
import { AccountingConfigurationsModel, AccountingEnvironmentEnum, AccountingSystemEnum } from 'src/app/core/models/accounting/account-settings.model';

@Component({
  selector: 'app-accounting-configuration',
  templateUrl: './accounting-configuration.component.html',
  styleUrls: ['./accounting-configuration.component.scss']
})
export class AccountingConfigurationComponent extends BaseModalComponent {

  accountingSystemList: { value: AccountingSystemEnum, selectedText: string, dropdownText: string }[] = [
    { value: AccountingSystemEnum.QuickBooks, selectedText: 'Quickbooks', dropdownText: 'Quickbooks' }
  ];

  accountingEnvironmentList: { value: AccountingEnvironmentEnum, selectedText: string, dropdownText: string }[] = [
    { value: AccountingEnvironmentEnum.Development, selectedText: 'Development', dropdownText: 'Development' },
    { value: AccountingEnvironmentEnum.Production, selectedText: 'Production', dropdownText: 'Production' },
    { value: AccountingEnvironmentEnum.Staging, selectedText: 'Staging', dropdownText: 'Staging' }
  ];

  accountingConfigurationsModel!: AccountingConfigurationsModel | undefined;

  @Input() public inputModel!: AccountingConfigurationsModel;
  @Input() public modelIndex!: number | undefined;

  @Output() modelChanged = new EventEmitter<AccountingConfigurationsModel>();

  override ngOnInit(): void {
    this.accountingConfigurationsModel = {
      system: this.inputModel.system,
      environment: this.inputModel.environment,
      companyId: this.inputModel.companyId,
      clientId: this.inputModel.clientId,
      clientSecret: this.inputModel.clientSecret,
      redirectUri: this.inputModel.redirectUri,
      state: this.inputModel.state,
      scope: this.inputModel.scope,
      apiBaseUrl: this.inputModel.apiBaseUrl,
      discoveryDocumentUrl: this.inputModel.discoveryDocumentUrl,
      tokenInfo: this.inputModel.tokenInfo,
      tokenEndpoint: this.inputModel.tokenEndpoint,
      objectMappings: this.inputModel.objectMappings,
      customFields: this.inputModel.customFields
    }
  }
  override ngOnDestroy(): void {
    this.accountingConfigurationsModel = undefined;
  }

  validate(): boolean {
    this.submitted = true;
    if (
      this.accountingConfigurationsModel !== undefined &&
      this.accountingConfigurationsModel.clientId && this.accountingConfigurationsModel.clientId.length > 1 &&
      this.accountingConfigurationsModel.apiBaseUrl && this.accountingConfigurationsModel.apiBaseUrl.length > 1 &&
      this.accountingConfigurationsModel.companyId && this.accountingConfigurationsModel.companyId.length > 1 &&
      this.accountingConfigurationsModel.clientSecret && this.accountingConfigurationsModel.clientSecret.length > 1 &&
      this.accountingConfigurationsModel.discoveryDocumentUrl && this.accountingConfigurationsModel.discoveryDocumentUrl.length > 1 &&
      this.accountingConfigurationsModel.environment !== undefined &&
      this.accountingConfigurationsModel.redirectUri && this.accountingConfigurationsModel.redirectUri.length > 1 &&
      this.accountingConfigurationsModel.system !== undefined &&
      this.accountingConfigurationsModel.scope && this.accountingConfigurationsModel.scope.length > 1 &&
      this.accountingConfigurationsModel.state && this.accountingConfigurationsModel.state.length > 1
    ) {
      return true;
    }
    this.toasterNotificationService.showWarning(`Enter all the fields`, `Missing Information`);
    return false;
  }

  override onUpdate(): void {
    if (this.validate()) {
      this.modelChanged.emit(this.accountingConfigurationsModel);
      this.close();
    }
  }

  override onCreate(): void {
    if (this.validate()) {
      // Construct the authorization URL
      const authorizeUrl = `https://appcenter.intuit.com/connect/oauth2?` +
        `client_id=${encodeURIComponent(this.accountingConfigurationsModel!.clientId)}&` +
        `response_type=code&` +
        `redirect_uri=${encodeURIComponent(this.accountingConfigurationsModel!.redirectUri)}&` +
        `scope=${encodeURIComponent(this.accountingConfigurationsModel!.scope)}&` +
        `state=${encodeURIComponent(this.accountingConfigurationsModel!.state)}`;
      // Redirect to the authorization URL


      var new_window = window.open(authorizeUrl, `_blank`, `popup=true,width=475,height=475`);

      var timer = setInterval( () => {
        if (new_window && new_window.closed) {
          clearInterval(timer);
           this.modalRef.close();
        }
      }, 1000);



      // if (new_window) {
      //   new_window.onbeforeunload = function () {
      //     this.close();
      //     return;
      //    }
      // }

      //  var new_window = window.open(authorizeUrl, `_blank`, `popup=true,width=475,height=475,screenX=' + window.leftScreenBoundry() + ' , left=' + window.leftScreenBoundry()`);
      // if (new_window) {
      //   $(new_window).on('beforeunload', function () {
      //     this.close();
      //     return;
      //   })
      // }
      localStorage.setItem("ConfigIndex", `${this.modelIndex}`);
    }
  }

}
